export class ProductUrl {
  private readonly url: string;
  private readonly params: string[];

  constructor(url: string) {
    this.url = url;
    this.params = [];
  }

  public appendToParams(key: string, value?: string) {
    if (typeof value === 'undefined') return;
    this.params.push(`${key}=${value}`);
  }

  public getUrl() {
    let url = this.url;

    if (this.params.length) {
      url += `?${this.params.join('&')}`;
    }

    return encodeURI(url);
  }
}
